import * as React from 'react';
import isEmpty from 'lodash/isEmpty';
import { DetailsBooking } from 'types';
import { ContentHeading } from 'components/Typography';
import BottomTotal from 'components/BottomTotal';
import LineItem from 'components/LineItem';
import PaymentsCard from 'components/PaymentsCard';

const CancellationSummary: React.FC<{ booking: DetailsBooking }> = ({ booking }) =>
  booking.cancellationRefund ? (
    <>
      <ContentHeading data-testid="booking-cancellation-summary">Cancellation summary</ContentHeading>
      <PaymentsCard>
        <LineItem
          data-testid="cancellation-paid-to-date-amount"
          title="Total paid to date"
          totals={booking.paidBeforeCancellation.totals}
        />
        {!isEmpty(booking.cancellationRefund.penalty) && (
          <LineItem data-testid="cancellation-penalty-amount" title="Penalty & charges" totals={booking.cancellationRefund.penalty} />
        )}
        <BottomTotal data-testid="cancellation-refund-amount" title="Total refund" totals={booking.cancellationRefund.totals} />
      </PaymentsCard>
    </>
  ) : null;

export default CancellationSummary;
